/*
 * Diagnostyka polaczen jaws (WebSocket).
 *
 * DOMYSLNIE WYLACZONA - nie wykonuje sie nic poza sprawdzeniem flagi.
 * Wlaczenie w konsoli przegladarki:
 *     localStorage.setItem('jawsDebug', '1'); location.reload();
 * Wylaczenie:
 *     localStorage.removeItem('jawsDebug'); location.reload();
 *
 * Nie loguje tokenow, adresow ani danych klienta - wylacznie cykl zycia polaczen.
 * Po wlaczeniu instancje sa dostepne w konsoli jako window.__jaws
 */

let enabled = false;
try {
  enabled = localStorage.getItem('jawsDebug') === '1';
} catch (e) {
  enabled = false; // prywatne okno / zablokowane storage
}

export const jawsDebugEnabled = enabled;

export function jawsLog(source, event, details) {
  if (!enabled) return;
  const stamp = new Date().toISOString().substr(11, 12);
  // eslint-disable-next-line no-console
  console.log(`[jaws ${stamp}] ${source}: ${event}`, details === undefined ? '' : details);
}

/** Udostepnia instancje w window.__jaws, zeby dalo sie ja obejrzec z konsoli. */
export function jawsRegister(source, instance) {
  if (!enabled) return instance;
  window.__jaws = window.__jaws || {};
  window.__jaws[source] = window.__jaws[source] || [];
  window.__jaws[source].push(instance);
  jawsLog(source, 'utworzono instancje', {
    numer: window.__jaws[source].length,
    useWebSockets: instance && instance.useWebSockets,
  });
  return instance;
}

/** Zwraca stan wszystkich zarejestrowanych instancji - do recznego wywolania z konsoli. */
export function jawsSnapshot() {
  const out = {};
  const all = (typeof window !== 'undefined' && window.__jaws) || {};
  Object.keys(all).forEach(source => {
    out[source] = all[source].map((i, idx) => ({
      nr: idx + 1,
      state: i && i.state,
      useWebSockets: i && i.useWebSockets,
    }));
  });
  return out;
}

/*
 * Loguje przejscia karty w tlo i z powrotem wraz ze stanem polaczen.
 * To jest sedno diagnozy: chcemy zobaczyc, ktore gniazdo przezylo uspienie karty,
 * czy ktores probuje sie wznowic i czy useWebSockets nie zostalo wylaczone na stale.
 */
export function watchJawsVisibility() {
  if (!enabled || watchJawsVisibility.started) return;
  watchJawsVisibility.started = true;

  let hiddenAt = null;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now();
      jawsLog('visibility', 'karta ukryta', jawsSnapshot());
    } else {
      const sekund = hiddenAt ? Math.round((Date.now() - hiddenAt) / 1000) : null;
      jawsLog('visibility', `karta wrocila po ${sekund}s`, jawsSnapshot());
    }
  });

  if (typeof window !== 'undefined') {
    window.jawsSnapshot = jawsSnapshot;
  }
  jawsLog('debug', 'diagnostyka aktywna - window.__jaws / window.jawsSnapshot()');
}
